import React, { useState } from 'react';
import classes from './Education.module.css';
import { BsGithub, BsInstagram, BsLinkedin } from 'react-icons/bs';
import { useRef, useEffect } from 'react';
import 'intersection-observer';

const Education = (props) => {
  const educationRef = useRef(null);
  const [animating, setAnimating] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Add a class to the component when it enters the viewport
          setAnimating(true);
        }
      });
    });

    observer.observe(educationRef.current);
  }, []);

  return (
    <div
      className={`${classes.education} + ${animating ? classes.animate : null}`}
      ref={educationRef}
      id='education'>
      <h2 className={classes.title}>My Education</h2>
      <p className={classes.p}>
        I graduated from Izmir Science High School in 2017. Following that, in
        2018, I was accepted to the Department of Computer Engineering at
        IZTECH, where I successfully completed a 5-year education program
        comprising 1 year of English Preparatory School and 4 years of
        undergraduate studies. In 2023, I graduated from IZTECH.
      </p>
    </div>
  );
};

export default Education;
